import Swal from "sweetalert2";

const ModalSuccess = (message, title, props) =>
  Swal.fire({
    title: title ? title : "Success",
    text: message ? message : "Data has been saved",
    icon: "success",
    confirmButtonText: "OK",
    didOpen: () => {
      const container = document.querySelector(".swal2-container");
      if (container) {
        container.style.zIndex = "9999";
      }
    },
    ...props,
  });

export default ModalSuccess;
